import { hostingPages } from '@/data/hostingPages'

/**
 * Where a framework name should link.
 *
 * Pages are published in waves, so a framework without content yet falls back to
 * the PaaS product page instead of a 404. The moment its entry lands in
 * `hostingPages`, every link on the site (footer, PaaS grid, related section)
 * points at the dedicated page without another edit.
 */
export function hostingPathForSlug(slug: string): string {
  return hostingPages[slug] ? `hosting/${slug}` : 'paas'
}
